import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { nonProdEnvironmentLabel } from '../config/environment';
/** P5.3: small "TEST" / "LOCAL" chip, shown only when not on production. */
export function EnvironmentBadgeView({ environment, }) {
    const label = nonProdEnvironmentLabel(environment);
    if (!label) {
        return null;
    }
    return (<View style={styles.chip} testID="environment-badge" accessibilityLabel={`${label} environment`}>
      <Text style={styles.text}>{label}</Text>
    </View>);
}
const styles = StyleSheet.create({
    chip: {
        alignSelf: 'center',
        backgroundColor: '#B45309',
        borderRadius: 4,
        paddingHorizontal: 6,
        paddingVertical: 1,
        marginTop: 4,
    },
    text: {
        color: '#FFFFFF',
        fontSize: 10,
        fontWeight: '700',
        letterSpacing: 0.5,
    },
});
